import { Route } from "@dashboard/components/Router";
import { sectionNames } from "@dashboard/intl";
import { asSortParams } from "@dashboard/utils/sort";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { RouteComponentProps, Switch } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import ExchangeRateList from "./ExchangeRateList";
import * as mutations from "./mutations";
import * as queries from "./queries";
import {
  exchangeRateListPath,
  ExchangeRateListUrlQueryParams,
  ExchangeRateListUrlSortField,
} from "./urls";

// Re-export for convenience
export { mutations, queries };

const ExchangeRateListView: React.FC<RouteComponentProps> = ({ location }) => {
  const qs = parseQs(location.search.substr(1)) as any;
  const params: ExchangeRateListUrlQueryParams = asSortParams(qs, ExchangeRateListUrlSortField);

  return <ExchangeRateList params={params} />;
};

export const ExchangeRateSection: React.FC = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle title={intl.formatMessage(sectionNames.exchangeRates)} />
      <Switch>
        <Route exact path={exchangeRateListPath} component={ExchangeRateListView} />
      </Switch>
    </>
  );
};

export default ExchangeRateSection;
